module.exports = __webpack_public_path__ + "static/assets/b3dd5d2d612ca4a5a6f5fe5bce800e3b.png";